import AddContent from './AddContent';

export default AddContent;
